import React from 'react';
import PropTypes from 'prop-types';
import { render, unmountComponentAtNode } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import Module from './Module';
import ModuleConfig from './Module.json';
import ModuleData from './ModuleData.json';

const [family, module] = ModuleConfig.namespace.split(/\./);

const Index = props => {
  let basename = '/';

  if (props && props.moduleData) {
    const merchant = props.moduleData.merchant;
    basename = `${family}/${merchant.id}/${module}`;
  }

  return (
    <MuiThemeProvider>
      <BrowserRouter basename={basename}>
        <Module moduleData={props.moduleData} />
      </BrowserRouter>
    </MuiThemeProvider>
  );
};

Index.propTypes = {
  moduleData: PropTypes.object,
};

const error = err => {
  document.dispatchEvent(
    new CustomEvent('module-error', {
      detail: {
        module: ModuleConfig.namespace,
        message: err,
      },
    })
  );
};

console.log('Executed Before Everything else'); // eslint-disable-line no-console

// is it runnig on core or stand alone?
if (window.fourAll) {
  console.log('Module is Running on Core'); // eslint-disable-line no-console
  window.fourAll.module[family][module] = {
    load: data => {
      try {
        console.log('Loading Module', window.fourAll.module[family][module]); // eslint-disable-line no-console
        if (data) console.log('Received Data from Core', data); // eslint-disable-line no-console
        render(<Index moduleData={data} />, document.getElementById(ModuleConfig.id));
        console.log('Module Load Succeed'); // eslint-disable-line no-console
      } catch (ex) {
        console.log(`Error on load module ${ModuleConfig.id}`, ex); // eslint-disable-line no-console
        error(ex);
      }
    },
    unload: () => {
      try {
        unmountComponentAtNode(document.getElementById(ModuleConfig.id));
      } catch (ex) {
        console.log(`Error on unload module ${ModuleConfig.id}`, ex); // eslint-disable-line no-console
        error(ex);
      }
    },
  };
} else {
  console.log('Module is Running Stand Alone'); // eslint-disable-line no-console
  render(<Index moduleData={ModuleData} />, document.getElementById(ModuleConfig.id));
}



// WEBPACK FOOTER //
// ./src/index.js